/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { ApplicationDetailPageService } from '@/pages/ApplicationDetail/services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'workPermitDraft.machines.states';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};

export const appealApplication = async (context: any, event: any) => {
  console.log(`in appeal application:`, event);
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();
      console.log(`payload in appeal appplication ::::`, event?.payload);
      const data: any = await src.agent.appealApplication(event?.payload);
      console.log('ddttaa->', data);
      if (data) {
        return resolve({
          key: 'APPEAL_APPLICATION_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        return reject({
          key: 'APPEAL_APPLICATION_ERROR',
          value: 'Invite Failed',
        });
      }
    } catch (err: any) {
      return reject({
        key: 'APPEAL_APPLICATION_ERROR',
        value: err?.message,
      });
    }
  });
};
